<template>
  <div class="flex min-h-screen parent-wrapper">
    <slot />
  </div>
</template>

<style scoped>
/* .dark {
  .parent-wrapper {
    background:
      radial-gradient(ellipse at top, var(--color-primary), transparent),
      radial-gradient(ellipse at bottom, var(--color-secondary), transparent);
  }
}

.light {
  .parent-wrapper {
    background:
      radial-gradient(ellipse at top, var(--color-secondary-100), transparent),
      radial-gradient(
        ellipse at bottom,
        var(--ui-color-primary-200),
        transparent
      );
  }
} */
</style>
